import React from 'react'
import { DragDropContainer } from 'react-drag-drop-container';

export const Char = (props) => { 
    const { item, targetKey } = props;
    return (

        <DragDropContainer
            targetKey={targetKey}
            dragData={item}
          >
            <div className="charWrapperSlider">
                <img alt="thumb" src={item.src} />
            </div>
          </DragDropContainer>
        
    )
}

export default Char;